import { Box, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

const AgentConfigurationHelpPanel: React.FC = () => (
  <SpaceBetween size="m">
    <Box>
      <h3>Agent Configuration</h3>
      <p>
        Control which Bedrock model powers MAMBA and the season each sport
        treats as &quot;current&quot;.
      </p>
    </Box>
    <Box>
      <h3>Active model</h3>
      <ul>
        <li>
          Only tool-use-capable Anthropic (Claude) and Amazon (Nova) models are
          offered, since the agent relies on tool use.
        </li>
        <li>
          Changing the model affects all users and takes effect within about a
          minute (no redeploy needed). You&apos;ll be asked to confirm.
        </li>
      </ul>
    </Box>
    <Box>
      <h3>Season context</h3>
      <ul>
        <li>
          Enter the <strong>current</strong> season for each sport; the agent
          derives the previous season from the value and its format.
        </li>
        <li>
          Use <strong>Add sport</strong> to configure a new sport — the agent
          reads all configured sports, not a fixed NBA/WNBA set.
        </li>
      </ul>
    </Box>
  </SpaceBetween>
);

export default AgentConfigurationHelpPanel;
